import { takeLatest, call, put } from 'redux-saga/effects'
import { FETCH_TRACKING_LOAD, FETCH_TRACKING_LOADS, SET_LOADS, SET_TRACKING_LOAD, SET_SELECTED_LOAD, SET_CHECK_CALLS, FETCH_AND_SET_INCOMING_TEXT_BY_LOAD, SET_LOAD_POSITIONS, ADD_MESSAGE } from '../actionTypes'
import { fetchTrackingLoads } from '../trackingActions'
import { fetchCheckCalls, fetchLoad, fetchLoadPositions } from '../loadActions'



// worker saga: makes the api call when watcher saga sees the action
function* workerFetchTrackingLoads() {
  try {
    yield put({ type: SET_LOADS, loads: [] })
    const loads = yield call(fetchTrackingLoads)
    yield put({ type: SET_LOADS, loads: loads })

  } catch (error) {
    // dispatch a failure action to the store with the error
    console.log("error on fetch tracking loads saga ", error)
  }
}

function* workerSetTrackingLoad(payload) {

  //refetch it to get all of the other data
  const resp = yield call(fetchLoad, payload.load.pro)
  const load = resp.data

  // fetch all relevant data
  yield put({ type: SET_SELECTED_LOAD, selectedLoad: load })

  //      yield put({type: SET_SELECTED_CARRIER, selectedCarrier: task?.load?.carrier})
  yield put({ type: FETCH_AND_SET_INCOMING_TEXT_BY_LOAD, load })

  yield put({ type: SET_CHECK_CALLS, checkcalls: [] })
  const ccResponse = yield call(fetchCheckCalls, load?.id)
  if (ccResponse?.data) {
    yield put({ type: SET_CHECK_CALLS, checkcalls: ccResponse.data })
  }
  //fetch the carrier

  //fetch the sms chats
  yield put({type: FETCH_AND_SET_INCOMING_TEXT_BY_LOAD, load})

  //fetch the posisions
  yield put({ type: SET_LOAD_POSITIONS, positions: [] })
  const lpResponse = yield call(fetchLoadPositions, load.id)
  if (lpResponse?.data) {
    yield put({ type: SET_LOAD_POSITIONS, positions: lpResponse.data })
  }
}

function* workerFetchTrackingLoad(payload) {
  const {pro} = payload

  try {
    const resp = yield call(fetchLoad, pro)
    if (resp?.data?.id) {
      if (pro === resp.data.pro) {
        yield put ({type: SET_TRACKING_LOAD, load: resp.data})
      } else {
        yield put({type: ADD_MESSAGE, message: `load for ${pro} not found`})
      }
    } else {
      yield put({type: ADD_MESSAGE, message: `load for ${pro} not found`})
    }
  } catch (ex) {
    yield put({type: ADD_MESSAGE, message: ex.message})
  }

}

export function* watchFetchTrackingLoadsSaga() {
  yield takeLatest(FETCH_TRACKING_LOADS, workerFetchTrackingLoads)
}

export function* watchFetchTrackingLoadSaga() {
  yield takeLatest(FETCH_TRACKING_LOAD, workerFetchTrackingLoad)
}

export function* watchSetTrackingLoadSaga() {
  yield takeLatest(SET_TRACKING_LOAD, workerSetTrackingLoad)
}


